import { useState, type VoidFunctionComponent } from 'react';
import { Modal } from 'react-bootstrap';

import { BUTTON_SIZE, BUTTON_TYPE, IconButton, icons, LoaderButton } from '../../../generic';
import useDeleteGitHubAppInstallation from './useDeleteGitHubAppInstallation';
import Flex from '../../../generic/Flex';

export type Props = {
  installationId: number;
};

const DeleteGitHubAppButton: VoidFunctionComponent<Props> = ({ installationId }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { error, isLoading, mutate: deleteGitHubApp, reset } = useDeleteGitHubAppInstallation();

  const onOpen = () => setIsOpen(true);
  const onClose = () => {
    setIsOpen(false);
    reset();
  };

  const onSubmit = () => {
    deleteGitHubApp({ installationId }, { onSuccess: onClose });
  };

  return (
    <>
      <IconButton
        id={`delete-installation-${installationId}`}
        icon={icons.xMark}
        onClick={onOpen}
      />
      <Modal onHide={onClose} backdrop show={isOpen}>
        <Modal.Header closeButton>
          <Modal.Title>
            Delete GitHub App Installation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Flex direction="column" gap="16px">
            {
              error &&
              <p className="alert alert-error">Error while deleting installation: { error.message }</p>
            }
            <p className="alert">
              NOTE: This operation will break the connection between FOSSA and projects imported via the GitHub App.
              Features such as status checks and automatic revision detection will no longer work.
            </p>
          </Flex>
        </Modal.Body>
        <Modal.Footer>
          <LoaderButton
            isDisabled={isLoading}
            isLoading={isLoading}
            type={BUTTON_TYPE.ERROR}
            size={BUTTON_SIZE.MEDIUM}
            onClick={onSubmit}
            testId="submitDeleteInstallation"
          >
            Delete Installation
          </LoaderButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteGitHubAppButton;
